import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import * as glob from '../../../shared/global';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class SetttingGuard implements CanActivate {
    constructor(
        private _router: Router,
        private _httpClient: HttpClient
    ) {

    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this._httpClient.post<any>(glob.BASE_URL + 'intelisys/refresh-token', {}, {observe: 'response'})
            .pipe(map(res => {
                if (res.body.data.permission === 'SuperAdmin') {
                    return true;
                } else {
                    switch (res.body.data.permission) {
                        case 'Booking access permission':
                        case 'Booking override permission':
                        case 'Full permission':
                            this._router.navigate(['booking/create']);
                            break;
                        case 'Fare access permission':
                        case 'Fare modify permission':
                            this._router.navigate(['session/list']);
                            break;

                    }

                    return false;
                }

            }));

    }
}
